import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LanguagesService } from "../languages.service";

@Injectable()
export class UrlLanguageInterceptor implements HttpInterceptor {
    
    private languageRegex = /:current_language:/g;

    constructor(
        private languagesService: LanguagesService
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        if(!this.languageRegex.test(req.url)) {
            return next.handle(req);
        }

        const currentLanguage = this.languagesService.currentLanguage;
        const url = req.url.replace(this.languageRegex, currentLanguage.language);
        const updatedReq = req.clone({ url: url });
        return next.handle(updatedReq);
    }
}